import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ButtonLink } from '../ButtonLink/ButtonLink';
import icon from './action-icon-ios7.png';

const text = (content: string) => ({
    __html: content.replace('{icon}', `<img src=${icon} alt="Share icon" style="height: 1rem;" />`),
});

interface HelpProps {
    translations: Record<string, string>;
}

export const Help: React.FC<HelpProps> = ({ translations }) => (
    <Box textAlign="center" mt={8}>
        <Typography variant="h5" gutterBottom>
            {translations.HELP_IOS_HOMESCREEN_TITLE}
        </Typography>
        <Typography
            variant="subtitle1"
            gutterBottom
            dangerouslySetInnerHTML={text(translations.HELP_IOS_HOMESCREEN_ADD)}
        />

        <Box mt={8}>
            <ButtonLink to="/" text={translations.GLOBAL_HOME_BUTTON} />
        </Box>
    </Box>
);
